import { render, staticRenderFns } from "./StartRecording.vue?vue&type=template&id=1c8818ec&scoped=true"
import script from "./StartRecording.vue?vue&type=script&lang=js"
export * from "./StartRecording.vue?vue&type=script&lang=js"
import style0 from "./StartRecording.vue?vue&type=style&index=0&id=1c8818ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8818ec",
  null
  
)

export default component.exports